module.exports = __webpack_public_path__ + "76a7a39e11d32487b82b58046c23e708.svg";